import { InjectionToken } from '@angular/core';

import { type CalendarConfig } from '../calendar.models';

export const CALENDAR_CONFIG = new InjectionToken('CALENDAR_CONFIG');

export const calendarConfig: CalendarConfig = {
  oneHourHeight: 64,
  defaultDayViewColumnWidthPx: 280,
  minDayViewColumnWidthPx: 100,
  maxVisibleCalendars: 1,
};
